import { Component, input, inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiComponentsModule } from '@mwe/ui/components';
import { CommonModule } from '@angular/common';
import { ORGANIZATION_CONTACT_DATA_KEY } from '../../../model/occupied_contract_partner.model';
import { buildOrganizationFormWithDefaultValues } from '../../../current-contract-partner-form-builder';

@Component({
  selector: 'ikp-organization-contact-data',
  standalone: true,
  templateUrl: './organization-contact-data.component.html',
  imports: [UiComponentsModule, FormsModule, ReactiveFormsModule, CommonModule],
})
export class OrganizationContactDataComponent implements OnInit, OnDestroy {
  parentForm = input<FormGroup>();
  private formBuilder = inject(FormBuilder);

  ngOnInit(): void {
    this.parentForm().addControl(ORGANIZATION_CONTACT_DATA_KEY, buildOrganizationFormWithDefaultValues(this.formBuilder));
  }

  ngOnDestroy(): void {
    this.parentForm()?.removeControl(ORGANIZATION_CONTACT_DATA_KEY);
  }

  get organizationContactDataForm(): FormGroup {
    return this.parentForm().get(ORGANIZATION_CONTACT_DATA_KEY) as FormGroup;
  }

  isInputInvalid(key: string) {
    const form = this.parentForm().get(key);
    return form.touched && form.invalid;
  }

  getFormError(key: string): string {
    const formKey = this.parentForm().get(key);
    if (formKey.errors) {
      return formKey.errors.translationKey;
    }
    return null;
  }

  protected readonly ORGANIZATION_CONTACT_DATA_KEY = ORGANIZATION_CONTACT_DATA_KEY;
}
